import { css } from 'styled-components';

export const checkBoxRoundedCss = css`
  .Polaris-Checkbox__Backdrop,
  .Polaris-Checkbox__Backdrop:checked,
  .Polaris-Checkbox__Backdrop:before {
    border-radius: 50%;
  }

  .Polaris-Checkbox__Backdrop:checked {
    border-color: ${({ theme }) => theme.colors.primary.hex} !important;
    background-color: ${({ theme }) => theme.colors.primary.hex};
  }
`;

export const fixedAtTopCss = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
`;
